const kasraServiceName = "/outsources/KasraSystem";

export function kasraService(http) {
    return {        
        getHashCode: (personnelCode) => {
            return http.get(kasraServiceName + `?personnelCode=${personnelCode}`)
        },
        
    }
}
